import React from 'react';
import PropTypes from 'prop-types';
import { format as formatDate } from 'date-fns';
import { Text, Flex } from 'roo-ui/components';
import { DISPLAY_DATE_FORMAT } from 'config';

const StayDates = ({ checkIn, checkOut }) => {
  const formattedCheckIn = formatDate(checkIn, DISPLAY_DATE_FORMAT);
  const formattedCheckOut = formatDate(checkOut, DISPLAY_DATE_FORMAT);

  return (
    <Flex flexDirection="row">
      <Flex flexDirection="column" flex="1 1 0%">
        <Flex justifyContent="space-between" mb={1}>
          <Text fontSize={['sm', 'base']}>Check-in</Text>
          <Text fontSize={['sm', 'base']} fontWeight="bold" color="greys.charcoal" data-testid="check-in">
            {formattedCheckIn}
          </Text>
        </Flex>
        <Flex justifyContent="space-between">
          <Text fontSize={['sm', 'base']}>Check-out</Text>
          <Text fontSize={['sm', 'base']} fontWeight="bold" color="greys.charcoal" data-testid="check-out">
            {formattedCheckOut}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

StayDates.propTypes = {
  checkIn: PropTypes.object,
  checkOut: PropTypes.object,
};

StayDates.defaultProps = {
  checkIn: null,
  checkOut: null,
};

export default StayDates;
